// sections/LiveStatsSection.tsx
import React from 'react';
import { LiveStats } from '../components/LiveStats';
import { useAnalytics } from '../../../contexts/AnalyticsContext';
import type { LiveStatsFilters } from '../../../shared/hooks/useLiveStats';

export const LiveStatsSection: React.FC = () => {
  const { filters: analyticsFilters } = useAnalytics();
  
  // ✅ USAR FILTROS DE ANALYTICS CONTEXT - Para todos los superadmin
  const liveStatsFilters: LiveStatsFilters = {
    adminId: undefined, // ✅ NO filtrar por admin - mostrar TODOS los admins
    accountName: analyticsFilters?.accountName === 'all' ? undefined : analyticsFilters?.accountName,
    dateRange: analyticsFilters?.dateRange ? {
      start: analyticsFilters.dateRange.start,
      end: analyticsFilters.dateRange.end
    } : undefined
  };


  return (
    <div style={{ 
      padding: 0,
      margin: 0,
      minHeight: '100vh',
      background: 'transparent'
    }}>
      <LiveStats 
        filters={liveStatsFilters}
        showHeader={false}
        compact={false}
      />
    </div>
  );
};